import { endpoints } from '../constants/endpoints';

import { BaseApi } from './index';

export class CreditApi extends BaseApi<any> {
  constructor() {
    super(endpoints.credit.base);
  }

  async getInitialCreditValue() {
    return this.get(endpoints.credit.initialValue);
  }

  async getReferralCreditValue() {
    return this.get(endpoints.credit.referralValue);
  }

  async updateInitialCreditValue(initialValue: number) {
    return this.patch(endpoints.credit.initialValue, {
      initialValue,
    });
  }

  async updateReferralCreditValue(referralValue: number) {
    return this.patch(endpoints.credit.referralValue, {
      referralValue,
    });
  }

  async getEnableBoosters() {
    return this.get(endpoints.credit.enableBoosters);
  }

  async updateEnableBoosters(enableBoosters: boolean) {
    return this.post(endpoints.credit.enableBoosters, {
      enableBoosters,
    });
  }
}
